import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import * as airActions from "../../redux/actions/airAction";
import * as stdActions from "../../redux/actions/stdAction";
import * as accomodationActions from "../../redux/actions/accomodationAction";
import * as ccmActions from "../../redux/actions/ccmAction";
import * as commonActions from "../../redux/actions/commonAction";
import * as profileActions from "../../redux/actions/profileAction";
import { useSelector, useDispatch } from "react-redux";
import PrefferedLanguage from "../../components/Settings/PrefferedLanguage";
import PropTypes from "prop-types";
import PendingApplicationComponent from "../../components/PendingApplicationDetail";

const PendingApplicationDetails = (props, context) => {
  const profileReducer = useSelector((state) => state.profileReducer);
  const dispatch = useDispatch();

  const modalAction = bindActionCreators(modalActions, dispatch);
  const airAction = bindActionCreators(airActions, dispatch);
  const stdAction = bindActionCreators(stdActions, dispatch);
  const acmdAction = bindActionCreators(accomodationActions, dispatch);
  const ccmAction = bindActionCreators(ccmActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);

  const airReducer = useSelector((state) => state.airReducer);
  const notificationReducer = useSelector((state) => state.notification);

  //   const profileAction = bindActionCreators(profileActions, dispatch);

  ///Call api after first render
  useEffect(() => {
    // profileAction.getLastLoginInfo(profileReducer);

  }, []);

  const getAirEmployeeStatement = (employerInformationId) => {
    airAction.getAirEmployeeStatement(employerInformationId);
  }

  const getStdEmployeeStatement = (employerInformationId) => {
    stdAction.getStdEmployeeStatement(employerInformationId);
  }

  const getAcmdEmployeeStatement = (employerInformationId) => {
    acmdAction.getAcmdEmployeeStatement(employerInformationId);
  }

  const getCCMEmployeeStatement = (employerInformationId) => {
    ccmAction.getCCMEmployeeStatement(employerInformationId);
  }

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const openSetModal = (children, size) => {
    modalAction.openSetModal(children, size);
  };

  const deleteEmployeeStatement = (employeeInformationId, applicationType) => {
    commonAction.deleteEmployeeStatement(employeeInformationId, applicationType, profileReducer.managersDetails.managerId);
  }

  // Close modal component on change component
  useEffect(() => {
    return () => {
      closeRemoveModal();
    };
  }, []);

  return (
    <PendingApplicationComponent
      context={context}
      closeRemoveModal={closeRemoveModal}
      openSetModal={openSetModal}
      allPendingApplications={notificationReducer.allPendingApplications}
      getAirEmployeeStatement={getAirEmployeeStatement}
      getStdEmployeeStatement={getStdEmployeeStatement}
      getAcmdEmployeeStatement={getAcmdEmployeeStatement}
      getCCMEmployeeStatement={getCCMEmployeeStatement}
      deleteEmployeeStatement={deleteEmployeeStatement}
      {...props}
    //   lastLoginDetails={profileReducer.lastLoginDetails}
    />
  );
};

// LastLoginDetails.contextTypes = {
//   t: PropTypes.func.isRequired,
// };
export default PendingApplicationDetails;
